export default "__VITE_ASSET__BakOI$2O__"